"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserSettingsBulkGetStatus = exports.getFetchUserSettingsRequestStatus = exports.getHideProductFoldersShepherd = exports.getFavoriteBlog = exports.getBlogUserSettings = exports.getUserSettings = void 0;

var _reselect = require("reselect");

var _selectors = require("settings-ui-sdk/RequestStatuses/selectors");

var _actions = require("settings-ui-sdk/UserSettings/actions");

var _constants = require("settings-ui-sdk/UserSettings/constants");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var getUserSettings = function getUserSettings(state) {
  return state.userSettings;
};

exports.getUserSettings = getUserSettings;
var getBlogUserSettings = (0, _reselect.createSelector)([getUserSettings], function (userSettings) {
  return userSettings.get(_constants.BLOG_SETTINGS_NAMESPACE);
});
exports.getBlogUserSettings = getBlogUserSettings;
var getFavoriteBlog = (0, _reselect.createSelector)([getBlogUserSettings], function (blogUserSettings) {
  return blogUserSettings && blogUserSettings.get('favoriteBlog');
});
exports.getFavoriteBlog = getFavoriteBlog;
var getHideProductFoldersShepherd = (0, _reselect.createSelector)([getUserSettings], function (userSettings) {
  return userSettings.get(_constants.HIDE_PRODUCT_FOLDERS_SHEPHERD) === 'true';
});
exports.getHideProductFoldersShepherd = getHideProductFoldersShepherd;

var getFetchUserSettingsRequestStatus = function getFetchUserSettingsRequestStatus(namespace, key, value) {
  return (0, _reselect.createSelector)([_selectors.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(_actions.UserSettingsActionTypes.FETCH_USER_SETTING + "&namespace=" + namespace + "&key=" + key + "&value=" + value) || _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.getFetchUserSettingsRequestStatus = getFetchUserSettingsRequestStatus;
var getUserSettingsBulkGetStatus = (0, _getRequestStatus.default)(_actions.UserSettingsActionTypes.BULK_GET_USER_SETTINGS);
exports.getUserSettingsBulkGetStatus = getUserSettingsBulkGetStatus;